import request from './base'

export default {
  /**
     * 文章添加
     */
  informationAddorupdate: (commit, payload, mutation) => {
    let options = request.getOptions('/information/addorupdate', payload)
    return request.post(commit, options, mutation)
  },
  /**
     * 文章添加/information/queryInformationType
     */
  informationQueryInformationType: (commit, payload, mutation) => {
    let options = request.getOptions('/information/queryInformationType', payload)
    return request.get(commit, options, mutation)
  },
  /**
   * 编辑信息
   * @param commit
   * @param payload
   * @param mutation
   * @returns {*}
   */
  updateBrowse: (commit, payload, mutation) => {
    let options = request.getOptions('/information/updateBrowse', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/management.js